import { observer } from "mobx-react";
import { Col, Container, Row } from "react-bootstrap";
import { portalStore } from "../../../../Stores/portal";
import QRCode from "react-qr-code";
import { firestore } from "../../../../firebase";
import { useEffect, useState } from "react";
import { addDoc, collection, deleteDoc, doc } from "firebase/firestore";

import { Timestamp } from "firebase/firestore";

export interface AuthCodeFirestore {
  id: string | null;
  deviceId: string | null;
  companyId: string;
  createdAt: Timestamp;
  expiryAt: Timestamp;
}

interface EmployeeGridType {}

const _EmployeeGrid: React.FC<EmployeeGridType> = () => {
  const [qrCodeVal, setQRCodeValue] = useState<string | null>(null);
  useEffect(() => {
    const _collection = collection(firestore, "scanner");

    const timerId = setTimeout(
      async () => {
        try {
          // 1. Delete the old document if it exists
          if (qrCodeVal != null) {
            await deleteDoc(doc(firestore, "scanner", qrCodeVal));
          }

          var current = Timestamp.now();
          var futureDate = new Date();
          futureDate.setDate(futureDate.getDate() + 30); //we add 30 days from today (looking to achieve the full-month)

          const newDocRef = await addDoc(_collection, {
            companyId: "testing",
            createdAt: Timestamp.now(),
            expiryAt: Timestamp.fromDate(futureDate),
            deviceId: null,
            id: null,
          } as AuthCodeFirestore);

          // 3. Update state with the new ID (this will trigger the next 60s cycle)
          setQRCodeValue(newDocRef.id);
        } catch (error) {
          console.error("Failed to cycle QR Code in Firestore:", error);
        }
      },
      1000 * 60 * 5,
    );

    // Cleanup: Clears the timeout if the component unmounts
    // or if qrCodeVal changes before the 5 seconds are up.
    return () => clearTimeout(timerId);
  }, [qrCodeVal]);
  return (
    <Container
      style={{ height: portalStore.portalHeight, backgroundColor: "tomato" }}
    >
      {/* 1. Set Row height to 100% so it inherits the Container's height */}
      <Row style={{ height: "100%" }}>
        <Col
          md={5}
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center", // Centers vertically
            alignItems: "center", // Centers horizontally
          }}
        >
          {/* 2. Move text alignment to the wrapper div */}
          <div style={{ textAlign: "center" }}>
            <h6>Scan the following QR Code</h6>
            {/* Note: An 800x800 QR Code will likely overflow a md={5} column on most screens. 
            Consider lowering it or making it responsive if it breaks out of the box. */}
            <QRCode height={256} width={256} value={qrCodeVal!!} />
          </div>
        </Col>

        <Col md={7}>kjkdjfdkfdkf</Col>
      </Row>
    </Container>
  );
};

export const EmployeeGrid = observer(_EmployeeGrid);
